import { ChangeDetectorRef, Component, ElementRef, ViewChild, ViewContainerRef } from "@angular/core";
import { TariffTable } from "../tariff-table/tariff-table";
import { Rule, SlabConfig, SlabSet, TariffRuleSet } from "../../../../models/tariff-rule-set";
import { FinanceApiService } from "../../../../services/finance-a-p-iervice.service";
import { LoadingService } from "../../../../services/loading.service";
import { ToasterService } from "../../../../services/toaster.service";
import { APIResponse } from "../../../../models/standard-response.interface";
import { DeterminantDetails } from "../../../../models/determinant-details";
import { FormBuilder, FormGroup } from "@angular/forms";
import { DynamicForm } from "../../../../models/dynamic-form";
import { TariffTableRulesComponent } from "../tariff-table/tariff-table-rules/tariff-table-rules.component";
import { RightPanelComponent } from "../../../right-panel/right-panel.component";
import { NgClass, NgForOf, NgIf } from "@angular/common";
import ManageTariffFormConfig from "../../config/ManageTariffFormConfig.json";
import SlabTableConfig from '../../config/SlabTable.config.json'
import ManageTariffCustomerAgreementFormConfig from "../../config/ManageTariffFCustomerAgreementFormConfig.json";
import { DynamicFormService } from "../../../../services/dynamic-form.service";
import { DynamicFormComponent } from "../../../dynamic-form/dynamic-form.component";
import { ActivatedRoute, Router } from "@angular/router";
import { PageCloseButtonComponent } from "../../../common/close-button/page-close-button.component";
import { TARIFF_ACTIONS, TariffService } from "../../../../services/tariff.service";
import { NoDataComponent } from "../../../no-data/no-data.component";
import { SvgIconComponent } from "../../../svg-icon/svg-icon.component";
import { EditableTableComponent } from "../../../editable-table/editable-table.component";
import { Subject, takeUntil } from "rxjs";
import { ConfirmDialogV2Component } from "../../../confirm-dialog/confirm-dialog-v2.component";
import { EditableTableHeader } from "../../../../models/editable-table-header.interface";
import { CommonUtils } from "../../../../utils/common-utils";
import { DeterminantType } from "../../../../constants/finance-constants";
import { FinanceService } from "../../../../services/finance-service.service";

@Component({
  selector: "app-manage-tariff",
  standalone: true,
  imports: [
    TariffTable,
    NgForOf,
    NgIf,
    DynamicFormComponent,
    NgClass,
    PageCloseButtonComponent,
    NoDataComponent,
    SvgIconComponent,
    EditableTableComponent
  ],
  templateUrl: "./manage-tariff.component.html",
  styleUrl: "./manage-tariff.component.scss"
})
export class ManageTariffComponent {
  private unsubscribe$ = new Subject<void>();

  manageTariffForm!: FormGroup;
  manageTariffFormConfig: DynamicForm = ManageTariffFormConfig;
  slabTableConfig: EditableTableHeader[] = SlabTableConfig.slabTableConfig ?? [];
  ruleSets: TariffRuleSet[] = [];
  commonCriteria: Rule[] = [];
  allDeterminants: DeterminantDetails[] = [];
  chargeId: string = "";
  tariffId: string = "";
  editingEnabled: boolean = false;
  readOnlyMode: boolean = false;
  activeTab: number = 1;
  routerNavigationAllowed: boolean = true;
  slabConfig: SlabConfig = {
    slabSet: [] = [],
    storageDeterminant: 'STORAGE_DAYS' // TODO: User Input
  };
  showSlabConfig: boolean = false

  @ViewChild('scrollContainer') scrollContainerRef: ElementRef | undefined;

  constructor(private financeApiService: FinanceApiService,
              private viewContainerRef: ViewContainerRef,
              private dynamicFormService: DynamicFormService,
              private fb: FormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private loadingService: LoadingService,
              private toasterService: ToasterService,
              private tariffService: TariffService,
              private financeService: FinanceService,
              private cdr: ChangeDetectorRef) {
    this.manageTariffForm = fb.group({});
  }

  ngOnInit() {
    this.chargeId = this.route.snapshot.paramMap.get("chargeId") || this.tariffService.currentState.chargeId;
    this.tariffId = this.route.snapshot.paramMap.get("tariffId") || this.tariffService.currentState.tariffId;
    this.routerNavigationAllowed = this.tariffService.currentState.routerNavigationAllowed ?? true;
    const showSlabParam = this.route.snapshot.queryParamMap.get("showSlab") ?? "";
    this.showSlabConfig = showSlabParam === 'true';
    this.tariffService.state$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (data) => {
        this.manageTariffFormConfig = data.agreementConfigurationId
          ? ManageTariffCustomerAgreementFormConfig
          : ManageTariffFormConfig;
      },
      error: () => {
        console.error("Error fetching form config");
        this.manageTariffFormConfig = ManageTariffFormConfig;
      }
    });

    this.dynamicFormService.addControlsToForm(this.manageTariffForm, this.manageTariffFormConfig);
    this.setupComponentMode();
    this.loadDeterminants();
    if (this.tariffId) {
      this.loadTariffDetails(this.tariffId);
    }
  }

  async loadDeterminants() {
    const determinantList = this.allDeterminants = await this.financeService.getDeterminants(DeterminantType.TARIFF, this.chargeId)
    this.allDeterminants = determinantList.sort((a: { displayName: string; }, b: {
      displayName: any;
     }) => a.displayName.localeCompare(b.displayName));
  }

  addRulesForCommonCriteria() {
    const panelComponentComponentRef = this.setUpRightPanel();

    const determinantRulesComponentRef = panelComponentComponentRef.instance.loadComponent(
      TariffTableRulesComponent
    );
    determinantRulesComponentRef.setInput("allDeterminants", this.allDeterminants);

    // if (this.commonCriteria.length !== 0)
    determinantRulesComponentRef.instance.patchRulesValueForCommonCriteria(this.commonCriteria);

    //check for apply all button of the right panel and then call the applyRules method of determinantRulesComponent
    panelComponentComponentRef.instance.primaryActionBtnEmitter.subscribe(() => {
      determinantRulesComponentRef.instance.applyRulesForCommonCriteria();
      if (determinantRulesComponentRef.instance.filterForm.valid) panelComponentComponentRef.destroy();
    });
    determinantRulesComponentRef.instance.applyAllButtonClicked.subscribe((commonCriteria: any) => {
      this.commonCriteria = commonCriteria;
    });
  }

  private setUpRightPanel() {
    const modalRef = this.viewContainerRef.createComponent(RightPanelComponent);
    modalRef.instance.title = "Add Rule";
    modalRef.instance.showActionBtns = true;
    modalRef.instance.primaryActionBtnText = "Apply";
    modalRef.instance.close.subscribe(() => {
      modalRef.destroy();
    });
    return modalRef;
  }

  goBack() {
    if (!this.routerNavigationAllowed) {
      this.tariffService.emitTariffAction(TARIFF_ACTIONS.GO_BACK);
      return;
    }
    this.router.navigateByUrl(`/manage-finance/charges/${this.chargeId}/tariffs`);
  }

  async saveTariff() {
    this.manageTariffForm.markAllAsTouched();
    if (!this.manageTariffForm.valid) {
      return;
    }

    if (this.ruleSets.length === 0) {
      this.toasterService.error("Please add at least one rule for tariff");
      return;
    }

    // Validate all tariff fields across all rule sets
    let hasEmptyFields = false;
    this.ruleSets.forEach((ruleSet, ruleSetIndex) => {
      ruleSet.values.forEach((row, rowIndex) => {
        row.forEach((cell, colIndex) => {
          if (!cell.minTariffExpression || !cell.tariffExpression) {
            hasEmptyFields = true;
          }
        });
      });
    });

    if (hasEmptyFields) {
      this.toasterService.error("Please fill all tariff fields in all rule sets before saving.");
      return;
    }

    await this.normalizeSlabs(this.slabConfig.slabSet);
    const saveTariffRequest = {
      ...this.manageTariffForm.value,
      fromTime: new Date(this.manageTariffForm.value.fromTime).getTime(),
      toTime: new Date(this.manageTariffForm.value.toTime).getTime(),
      chargeId: this.chargeId,
      rulesets: this.ruleSets,
      criteria: {
        rules: [...this.commonCriteria]
      },
      agreementConfigurationId: this.tariffService.currentState.agreementConfigurationId,
      slabConfig: this.slabConfig
    };


    this.editingEnabled ? this.callApiToUpdateTariff(saveTariffRequest, this.tariffId) : this.callApiToSaveTariff(saveTariffRequest);
  }

  private callApiToSaveTariff(saveTariffRequest: { rulesets: TariffRuleSet[]; commonCriteria: { rules: Rule[] } }) {
    this.loadingService.show();
    this.financeApiService.saveTariff(saveTariffRequest).subscribe({
      next: (res: any) => {
        this.loadingService.hide();
        this.toasterService.success(res.data);
        this.goBack();
      },
      error: (err) => {
        this.loadingService.hide();
        this.toasterService.error(err.error.message);
        console.error("Failed to save tariff", err.error);
      }
    });
  }

  getValuesToPrint(rule: Rule) {
    return this.tariffService.getValuesToPrint(rule);
  }

  private setupComponentMode(): void {
    if (this.tariffId) {
      const action = this.route.snapshot.url[0].path;
      this.editingEnabled = action === TARIFF_ACTIONS.EDIT || this.tariffService.currentState.appMode === TARIFF_ACTIONS.EDIT;
      this.readOnlyMode = !this.editingEnabled;
      if (this.readOnlyMode) {
        this.manageTariffForm.disable();
      }
    } else {
      this.readOnlyMode = false;
      this.editingEnabled = false;
    }
  }

  private async loadTariffDetails(tariffId: string) {
    this.loadingService.show();
    this.financeApiService.getTariffDetails(tariffId).subscribe({
      next: async (res: APIResponse) => {
        console.log("Tariff details response:", res);
        const data: any = res.data;
        this.showSlabConfig = data.storageCharge
        await this.unnormalizeSlabs(data.slabConfig.slabSet);
        this.manageTariffForm.patchValue(data);

        this.ruleSets = data.rulesets;
        this.slabConfig = CommonUtils.isNotNil(data.slabConfig.slabSet) ? data.slabConfig : this.slabConfig;
        if (!this.slabConfig?.storageDeterminant) {
          this.slabConfig.storageDeterminant = 'STORAGE_DAYS';
        }
        this.commonCriteria = data.criteria.rules;
        this.loadingService.hide();
      },
      error: (err) => {
        this.loadingService.hide();
        console.error("Failed to load tariff details", err);
      }
    });
  }

  activateTab(number: number) {
    this.manageTariffForm.markAllAsTouched();
    if (!this.manageTariffForm.valid && !this.readOnlyMode) {
      console.log("Form is invalid");
      return;
    }
    this.activeTab = number;
  }

  private callApiToUpdateTariff(saveTariffRequest: any, tariffId: string) {
    this.loadingService.show();
    this.financeApiService.updateTariff(tariffId, saveTariffRequest).subscribe({
      next: (res: any) => {
        this.loadingService.hide();
        this.toasterService.success(res.data);
        this.goBack();
      },
      error: (err) => {
        this.loadingService.hide();
        this.toasterService.error(err.error.message);
        console.error("Failed to save tariff", err);
      }
    });

  }

  getDisplayTextForDeterminant(determinantName: string | undefined) {
    return this.tariffService.getDisplayTextForDeterminant(determinantName, this.allDeterminants);
  }

  getDisplayTextForOperator(operatorValue: string | undefined) {
    return this.tariffService.getDisplayTextForOperator(operatorValue);
  }

  addNewSlab() {
    const slabSet = this.slabConfig.slabSet ?? [];

    if(!CommonUtils.isNotNil(slabSet)) return;

    // if(slabSet[slabSet.length-1]?.criteria.rules.length === 0){
    //   this.toasterService.error(`Please add a slab criteria for configuration ${slabSet.length} before adding new slabs`);
    //   return
    // }

    slabSet.push({
      criteria: {
        rules: []
      },
      slabs: [
        {
          id: 0,
          from: 0,
          to: 0,
          chargePerPeriod: 0,
          values: {
            minTariffExpression: "0",
            tariffExpression: "0"
          }
        }
      ]
    });

    setTimeout(() => {
      const container = this.scrollContainerRef?.nativeElement as HTMLElement;
      if (container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 100);
  }

  deleteSlab(index: number) {
    const confirmModalRef = this.viewContainerRef.createComponent(ConfirmDialogV2Component);
    confirmModalRef.instance.title = `Are you sure you want delete Slab Configuration ${index + 1}?`;
    confirmModalRef.instance.message = `This action cannot be undone.`;
    confirmModalRef.instance.confirm.subscribe(() => {
      this.slabConfig.slabSet.splice(index, 1);
      confirmModalRef.destroy()
      this.toasterService.success(`Slab Configuration ${index + 1} deleted successfully`);
    });
    confirmModalRef.instance.cancel.subscribe(() => {
      confirmModalRef.destroy();
    });
  }

  addNewSlabRange(index: number) {
    this.slabConfig.slabSet[index].slabs.push({
      id: this.slabConfig.slabSet[index].slabs.length + 1,
      from: 0,
      to: 0,
      chargePerPeriod: 0,
      values: {
        minTariffExpression: "0",
        tariffExpression: "0"
      }
    });
  }

  addSlabCriteria(index: number) {

    const panelComponentComponentRef = this.setUpRightPanel();

    const determinantRulesComponentRef = panelComponentComponentRef.instance.loadComponent(
      TariffTableRulesComponent
    );
    determinantRulesComponentRef.setInput("allDeterminants", this.allDeterminants);

    // if (this.commonCriteria.length !== 0)
    determinantRulesComponentRef.instance.patchRulesValueForCommonCriteria(this.slabConfig.slabSet[index].criteria.rules);

    //check for apply all button of the right panel and then call the applyRules method of determinantRulesComponent
    panelComponentComponentRef.instance.primaryActionBtnEmitter.subscribe(() => {
      determinantRulesComponentRef.instance.applyRulesForCommonCriteria();
      if (determinantRulesComponentRef.instance.filterForm.valid) panelComponentComponentRef.destroy();
    });
    determinantRulesComponentRef.instance.applyAllButtonClicked.subscribe((commonCriteria: any) => {
      this.slabConfig.slabSet[index].criteria.rules = commonCriteria;
    });
  }

  async normalizeSlabs(slabs: SlabSet[]) {
    slabs.forEach(set => {
      set.slabs.forEach((slab: any) => {
        slab.values = {
          tariffExpression: slab.tariffExpression ?? "0",
          minTariffExpression: slab.minTariffExpression ?? "0"
        };
        delete slab.tariffExpression;
        delete slab.id;
        delete slab.minTariffExpression;
      });
    });
  }

  async unnormalizeSlabs(slabs: SlabSet[]) {
    if(!CommonUtils.isNotNil(slabs)) return;
    slabs.forEach(set => {
      set.slabs.forEach((slab: any, index) => {
        slab.id = index;
        slab.tariffExpression = slab.values?.tariffExpression ?? "0";
        slab.minTariffExpression = slab.values?.minTariffExpression ?? "0";
      });
    });
  }

  deleteSlabRange(deletedData: any, slabIndex: number) {
    this.slabConfig.slabSet[slabIndex].slabs.splice(deletedData.rowIndex, 1);
  }

  cloneSlab(index: number) {
    const confirmModalRef = this.viewContainerRef.createComponent(ConfirmDialogV2Component);
    confirmModalRef.instance.title = `Are you sure you want clone Slab Configuration ${index + 1}?`;
    confirmModalRef.instance.message = `This action cannot be undone.`;
    confirmModalRef.instance.confirm.subscribe(() => {
      const cloningSlabSet = JSON.parse(JSON.stringify(this.slabConfig.slabSet[index]));
      this.slabConfig.slabSet.push(cloningSlabSet);
      confirmModalRef.destroy()
      this.toasterService.success(`Slab Configuration ${index + 1} cloned successfully`);
    });
    confirmModalRef.instance.cancel.subscribe(() => {
      confirmModalRef.destroy();
    });
  }
}


